
















import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class AnalysisSummary extends Slide {
  get text() {
    return this.data.Texts[`analysis_summary`];
  }
}
